import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {newGuid, getParam} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {stripCurrency} from '../../../shared/utilities';

declare const $: any;
declare function customAnswer(): void;
declare var noUiSlider: any;
declare var wNumb: any;

@Component({
    selector: 'app-question-checkbox-slider',
    templateUrl: './question-checkbox-slider.component.html',
    styleUrls: ['./question-checkbox-slider.component.scss'],
    standalone: false
})
export class QuestionCheckboxSliderComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() sliderStep = 1;
  @Input() sliderMin = 0;
  @Input() sliderMax = 0;
  @Input() sliderInit = 0;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() slideUpdate = new EventEmitter<{sliderValue: number}>();

  maskOptions: NgxCurrencyConfig;
  value = '';
  uniqueControlName = `label-amount-${newGuid()}`;
  uniqueId = newGuid();
  premium: any = 0;
  sliderEl: any;
  sliderInput: any;
  currencyFormat = wNumb({
    prefix: 'R ',
    thousand: ' ',
    decimals: 0
  });
  processing = false;
  hidePrem = false;
  constructor(public questionService: GlobalQuestionService) { }

  ngOnInit(): void {
    let param = JSON.parse(this.question.parameter);
    if (param?.length){
      this.hidePrem = getParam(param, 'hide_prem')?.value === '1';
    }
    //this.currencyFormat.prefix = '$ ';
    //this.currencyFormat.prefix = this.questionService?.currency.symbol;
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initAnswerControls();
      this.initRangeSliders();
      if (+this.question.answer > 0 && this.sliderEl){
        this.sliderEl.noUiSlider.set(+this.question.answer);
      }
    }, 1000);
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: '$ ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.sliderEl) {
      return;
    }
    
    if ( +changes?.sliderInit.currentValue !== +changes?.sliderInit.previousValue) {
      
      if (changes?.sliderMin || changes?.sliderMax || changes?.sliderInit || changes?.sliderStep) {
        const config = {
          min: changes?.sliderMin?.currentValue ?? this.sliderMin,
          max: changes?.sliderMax?.currentValue ?? this.sliderMax,
          init: changes?.sliderInit?.currentValue ?? this.sliderInit,
          step: changes?.sliderStep?.currentValue ?? this.sliderStep
        };

        if (changes?.sliderMin?.currentValue) {
          this.sliderMin = changes?.sliderMin?.currentValue;
        }
        if (changes?.sliderMax?.currentValue) {
          this.sliderMax = changes?.sliderMax?.currentValue;
        }
        if (changes?.sliderInit?.currentValue) {
          this.sliderInit = changes?.sliderInit?.currentValue;
          //this.sliderAmount = this.sliderInit;
          //this.slideUpdate.emit({sliderValue: this.sliderAmount});
        }
        if (changes?.sliderStep?.currentValue) {
          this.sliderStep = changes?.sliderStep?.currentValue;
        }

        if (changes?.readonly?.currentValue) {
          // this.readonly = changes?.readonly?.currentValue;
        }

        //this.updateSlider(config);
        //this.initRangeSliders();
      }
    }
  }

  saveAnswer(question: Question): void {
    this.questionService.saveAnswerOnly(question).subscribe();
  }
  initAnswerControls(): void {
    var answerControls = [];
      $('.custom-answer__group').each(function (i) {
         answerControls[i] = new customAnswer();
         answerControls[i].init($(this), function (state) {
            // callback that fires on invalid state
            //console.log(state);
         });
      });
  }
  getPremium(): void{  
    if (!this.hidePrem) {
      //console.log(this.question)
      this.questionService.getPremium(this.question.product_class_id, this.question?.item_id, this.question?.product_id, this.question?.vaps_id)
        .subscribe(prem => {
          if (prem?.length) {
            this.premium = prem[0].premium;
          }
          else {
            this.premium = 0;
          }
          this.processing = false;
        }, error => { this.processing = false });
    }
  }
  initRangeSliders(): void {
   
      this.sliderEl = document.getElementById(`slider${this.uniqueId}`);
      this.sliderInput = document.getElementById(`sliderinput${this.uniqueId}`);
      
    if (this.question.answer === '' && !this.sliderInit){
      this.sliderInit = this.sliderMin;
      this.question.answer = this.sliderMin.toString();
    }
      // grab settings from data-attributes
    var config = {
      min: this.sliderMin ?? 0,
      max: this.sliderMax ?? 10000,
      init: this.sliderInit ?? 0,
      step: this.sliderStep ?? 1
    };
      if (!!matchMedia("(pointer:coarse)").matches) {
         var behaviourSetting = "none";
      } else {
         var behaviourSetting = "tap";
      }

      noUiSlider.create(this.sliderEl, {
         start: config.init,
         step: config.step,
         connect: [true, false],
         format: this.currencyFormat,
         behaviour: behaviourSetting,
         range: {
            min: config.min,
            max: config.max,
         },
         pips: {
            mode: "count",
            values: 2,
            density: 100,
            format: this.currencyFormat,
         },
      });


      if (!!this.sliderInput) {
         this.sliderEl.noUiSlider.on("update", (values: any, handle: any) => {
            this.sliderInput.value = values[handle];  
         });
         this.sliderInput.addEventListener("change", (value: any) => {
            //this.sliderEl.noUiSlider.set(value);                
         });
         // NEW: trigger input change event
         this.sliderEl.noUiSlider.on("set", (value: any) => {
            this.question.answer = stripCurrency(value[0]);
            this.questionService.saveAnswerOnly(this.question).subscribe( val => {
              this.getPremium();
            });
            this.questionAnswer.emit(this.question);
         });
      }
  }
  onInputChange(event: any): void {

    let value = event?.target?.value;
    if (value && this.sliderEl) {
      value = this.currencyFormat.from(value);
      /*value = +value;*/
      if (isNaN(value)) {
        return;
      }
      this.sliderInput.value = value;
      if(value > this.sliderMax) {
      let input = $(this.sliderInput);
       input.addClass('has-error');
       input.after('<div class="form-control-error">Max amount exceeded</div>');               
        setTimeout(function(){
          input.removeClass('has-error');
          input.next('.form-control-error').remove();
        }, 2000);
     }

      if (this.sliderMax && (value > this.sliderMax)) {
        value = this.sliderMax;
      } else if (!this.sliderMax && (value > 10000)) {
        value = 10000;
      }
      if (this.sliderMin && (value < this.sliderMin)) {
        value = this.sliderMin;
      } else if (!this.sliderMin && (value < 0)) {
        value = 0;
      }
      this.processing = true;
      this.sliderEl.noUiSlider.set(value);
    }
  }
  checkChecked(): boolean {
    return (+this.question?.answer > 0)
  }
  isAllowed(): boolean {
    if (this.question?.min_val === 0){
      this.question.answer = '0';
      this.sliderEl.noUiSlider.set(0);
      this.questionService.saveAnswerOnly(this.question).subscribe();
      return true;
    }
    else{
      return false;
    }
    
  }
}
